module.exports = __webpack_public_path__ + "img/dxctj-5000.c6cb2df2.jpg";